import * as actionTypes from '../constants/userInfoConstants'

export function login(data) {
    return {
        type: actionTypes.USERINFO_LOGIN,
        data
    }
}

export function updateCityName(data) {
    return {
        type: actionTypes.UPDATE_CITYNAME,
        data
    }
}


// WEBPACK FOOTER //
// ./src/actions/userInfoActions.js